import BannerSection from "@/src/features/home/sections/BannerSection/BannerSection";
import ProgramsSection from "./sections/ProgramsSection/ProgramsSection";
import AnnouncementsSection from "./sections/AnnouncementsSection/AnnouncementsSection";
import ArticlesSection from "./sections/ArticlesSection/ArticlesSection";
import TeamSection from "./sections/TeamSection/TeamSection";
import OpinionsSection from "./sections/OpinionsSection/OpinionsSection";
import GallerySection from "./sections/GallerySection/GallerySection";

export default function HomePage() {
  return (
    <>
      <BannerSection />
      <ProgramsSection />
      <AnnouncementsSection />
      <ArticlesSection />
      <TeamSection />
      <OpinionsSection />
      <GallerySection />
    </>
  );
}
